import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  ResponsiveBox,
} from "../primitives";
import { BILLER_CROSS_REFERENCE_PROFILE_TABLE_ROWS } from "../../constants/BillerCrossReferenceProfileTableConfig";
import ERPSBaseLink from "../custom/inputs/ERPSBaseLink";
import { getServiceAgreement } from "../../utils/helper";


const BillerCrossReferenceProfileComparisonTable = ({ rowData }) => {
  const { t } = useTranslation();
  const loginUser = useSelector((state) => state.loginUserReducer?.user);
  const updatedDate = (date) =>
      date?.toString()?.replace(/(\d{4})(\d{2})(\d{2})/g, "$1/$2/$3");

  const getPdfFile = () => {
    const agreementUser = buildAgreementUserFromBcrRow(loginUser, rowData);
    if (!agreementUser) {
      return "";
    }
    const serviceAgreement = getServiceAgreement(agreementUser, {useBillPayPortalAgreement: true});
    if (serviceAgreement) {
      return loginUser?.languageCode === "F"
        ? serviceAgreement.french
        : serviceAgreement.english;
    }
    return "";
  };

  const buildAgreementUserFromBcrRow = (loginUser, rowData) => {

    return {
      ...loginUser,
      billerCrossReferenceDto: {...rowData},
    };
  };

  const formatCell = (value) => {
    if (value == null || value === "") return "";
    if (typeof value === "object") return String(value);
    return String(value);
  };

  return (
    <ResponsiveBox sx={{ mt: 2, maxWidth: "100%" }}>
      <Typography variant="h2" component="h2" sx={{ mb: 2 }}>
        {t("erps.billermanagement.crossreference.profile.heading")}
      </Typography>
      <TableContainer
        component={Paper}
        elevation={0}
        sx={{
          overflowX: "auto",
          border: "1px solid",
          borderColor: "divider",
        }}
      >
        <Table size="small" aria-label={t("erps.billermanagement.crossreference.profile.tableAriaLabel")} sx={{ tableLayout: "fixed", width: "100%" }}>
          <TableHead>
            <TableRow>
              <TableCell component="th" scope="col" sx={{ fontWeight: 600, width: "28%"}}>
                {""}
              </TableCell>
              <TableCell component="th" scope="col" align="left" sx={{ fontWeight: 600, width: "24%"}}>
                {t("erps.billermanagement.crossreference.profile.columnBmo")}
              </TableCell>
              <TableCell component="th" scope="col" align="left" sx={{ fontWeight: 600, width: "24%"}}>
                {t("erps.billermanagement.crossreference.profile.columnBns")}
              </TableCell>
              <TableCell component="th" scope="col" align="left" sx={{ fontWeight: 600, width: "24%" }}>
                {t("erps.billermanagement.crossreference.profile.columnCibc")}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {BILLER_CROSS_REFERENCE_PROFILE_TABLE_ROWS.map((def, index) => (
              <TableRow
                key={def.labelKey}
                sx={{backgroundColor: index % 2 === 0 ? "action.hover" : "background.paper",}}
              >
                <TableCell component="th" scope="row" sx={{ fontWeight: 500 }}>
                  {t(def.labelKey)}
                </TableCell>
                <TableCell align="left">{formatCell(rowData[def.bmo])}</TableCell>
                <TableCell align="left">{formatCell(rowData[def.bns])}</TableCell>
                <TableCell align="left">{formatCell(rowData[def.cibc])}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Typography variant="body1" mt={2}>
        {t(
            "erps.canact.billerregistration.label.dateAgreementAccepted",
            "Date agreement accepted"
        )}{" "}
        :<br />
      </Typography>
      {rowData?.padAcceptedDate ? (
          <>
            <label className="test-label">
              {updatedDate(rowData.padAcceptedDate)}
            </label>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <ERPSBaseLink
                className="link__blue"
                target="_blank"
                label={t("erps.billerregistration.label.viewAgreement")}
                to={getPdfFile()}
            />{" "}
          </>
      ) : (
          <Typography variant="body1">
            {t("erps.billerregistration.label.datenotAgreementAccepted")}
          </Typography>
      )}
    </ResponsiveBox>


  );


};

export default BillerCrossReferenceProfileComparisonTable;
